export const INVALID_BREED_STATE_AT_OPEN = 'InvalidBreedStateAtOpen';
export const INVALID_WELLNESS_PLAN_TYPE = 'InvalidWellnessPlanType';
export const INVALID_PLAN_TYPE = 'InvalidPlanType';
export const WRONG_BREED_STATE = 'WrongBreedState';

/* I requested the change on backend but... (clown) */
export const INVALID_OTP = 'invalid or expired verification code';
